import { Stack, Flex, Badge, Box, Text } from '@chakra-ui/react';
import { badgeColor } from '../../utils/badgeFunction';

interface IOwnProps {
  title: string;
  status?: string;
  position?: number | string;
}

const ResultStepCard: React.FC<IOwnProps> = ({ title, status, position }) => {
  const badge = badgeColor(status || '');

  return (
    <Box
      w={'100%'}
      p={4}
      borderRadius="xl"
      bg="white"
      border="2px solid"
      borderColor="gray.200"
      boxShadow="md"
      transition="all 0.3s ease-in-out"
      _hover={{
        boxShadow: 'lg',
        transform: 'translateY(-2px)',
        borderColor: 'blue.300',
      }}
    >
      <Text fontSize="sm" fontWeight="bold" color="gray.800" mb={3}>
        {title}
      </Text>

      <Stack spacing={3}>
        <Flex align="center" justify="space-between">
          <Text fontSize="sm" fontWeight="bold" color="gray.800">
            Posição:
          </Text>
          <Flex
            align="center"
            justify="center"
            minW="50px"
            h="32px"
            px={3}
            borderRadius="lg"
            bg="blue.50"
            border="1px solid"
            borderColor="blue.200"
          >
            <Text fontSize="md" fontWeight="bold" color="blue.700">
              {position ?? '-'}
            </Text>
          </Flex>
        </Flex>

        <Flex align="center" justify="space-between">
          <Text fontSize="sm" fontWeight="bold" color="gray.800">
            Situação:
          </Text>
          <Badge
            borderRadius="lg"
            textAlign="center"
            py={1.5}
            px={4}
            bg={badge?.bgColor || 'gray.100'}
            color={badge?.color || 'gray.700'}
            fontWeight="bold"
            fontSize="xs"
            textTransform="capitalize"
            letterSpacing="wide"
            boxShadow="sm"
            border="1px solid"
            borderColor={badge?.color ? `${badge.color.split('.')[0]}.300` : 'gray.300'}
          >
            {status || 'N/A'}
          </Badge>
        </Flex>
      </Stack>
    </Box>
  );
};

export default ResultStepCard;
